<template>
  <div>
    <ativar-ou-inativar-associacao-dialog
      :is-ativar-ou-inativar-associacao-dialog-open.sync="isAtivarOuInativarAssociacaoTipoSolicitacaoFormularioDialogOpen"
      :is-associacao-ativa-mensagem="isAssociacaoAtivaMensagem"
      :loading="loading"
      :close-dialog="closeAssociarOuDesassociar"
      :confirmar-ativacao-ou-inativacao-da-associacao="confirmarAtivacaoOuInativacaoDaAssociacao"
    />

    <associar-formulario-edit
      :open-edit-formulario.sync="openEditFormulario"
      :formulario-associado="formularioAssociado"
      :ordens-permitidas="ordensPermitidas"
      @refetch-data="$emit('refetch-data')"
    />

    <v-data-table
      :headers="headers"
      :items="items"
      :acesso-disable="acessoDisable"
      hide-default-footer
      :item-class="cursorPointer"
      @click:row="openEditFomulario"
    >
      <template #[`item.nome`]="{ item }">
        <div class="d-flex align-center">
          <v-avatar
            :color="`${$vuetify.theme.dark ? 'primary' : '#DCDCDC'}`"
            size="32"
          >
            <span :class="`${$vuetify.theme.dark ? 'white--text' : 'primary--text'} font-weight-bold`">
              {{ item.formularioNome.toUpperCase().charAt(0) }}
            </span>
          </v-avatar>
          <div class="d-flex flex-column ms-3 text-capitalize">
            {{ item.formularioNome }}
          </div>
        </div>
      </template>

      <template #[`item.descricao`]="{ item }">
        <span class="text-capitalize">
          {{ item.formularioDescricao }}
        </span>
      </template>

      <template #[`item.ativo`]="{ item }">
        <v-chip
          class="v-chip-light-bg font-weight-semibold text-capitalize"
          small
          :class="`${item.ativo ? 'success--text' : 'secondary--text'}`"
          :color="`${item.ativo ? 'success' : 'secondary'}`"
        >
          {{ item.ativo ? "Ativa" : "Inativa" }}
        </v-chip>
      </template>

      <template #[`item.actions`]="{ item }">
        <v-menu
          left
          bottom
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              icon
              v-bind="attrs"
              class="ml-n5"
              color="primary"
              v-on="on"
            >
              <v-icon @click="ativarOuInativarAssociacaoItem(item)">
                {{ icons.mdiDotsVertical }}
              </v-icon>
            </v-btn>
          </template>

          <v-list v-if="acessoDisable">
            <v-list-item>
              <v-list-item-title
                role="button"
                class="d-flex align-end"
                @click="openAssociarOuDesassociar"
              >
                <v-icon
                  size="20"
                  class="mr-1"
                >
                  {{ isAssociacaoAtiva ? icons.mdiCloseThick : icons.mdiCheckBold }}
                </v-icon>
                <span class="text-capitalize"> {{ isAssociacaoAtivaMensagem }} </span>
              </v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import { computed, ref } from '@vue/composition-api'
import { mdiCheckBold, mdiCloseThick, mdiDotsVertical } from '@mdi/js'
import AtivarOuInativarAssociacaoDialog from '@/views/ativar-ou-inativar-associacao-dialog/AtivarOuInativarAssociacaoDialog.vue'
import AssociarFormularioEdit from './AssociarFormularioEdit.vue'
import TipoSolicitacaoService from '@/services/modules/TipoSolicitacaoService'

export default {
  components: {
    AtivarOuInativarAssociacaoDialog,
    AssociarFormularioEdit,
  },

  props: {
    items: {
      type: Array,
      default: () => [],
    },
    acessoDisable: {
      type: Boolean,
      default: true,
    },
  },

  setup(props, { emit }) {
    const isAtivarOuInativarAssociacaoTipoSolicitacaoFormularioDialogOpen = ref(false)
    const openEditFormulario = ref(false)
    const formularioAssociado = ref({})

    const loading = ref(false)
    const tipoSolicitacaoId = ref(0)
    const formularioId = ref(0)
    const isAssociacaoAtiva = ref(undefined)
    const isAssociacaoAtivaMensagem = ref('')

    function ativarOuInativarAssociacaoItem(item) {
      tipoSolicitacaoId.value = item.tipoSolicitacaoId
      formularioId.value = item.formularioId
      isAssociacaoAtiva.value = item.ativo
      isAssociacaoAtivaMensagem.value = item.ativo ? 'inativar' : 'ativar'
    }

    function openEditFomulario(item) {
      openEditFormulario.value = true
      formularioAssociado.value = item
    }

    const openAssociarOuDesassociar = () => {
      isAtivarOuInativarAssociacaoTipoSolicitacaoFormularioDialogOpen.value = true
    }
    const closeAssociarOuDesassociar = () => {
      isAtivarOuInativarAssociacaoTipoSolicitacaoFormularioDialogOpen.value = false
    }
    async function confirmarAtivacaoOuInativacaoDaAssociacao() {
      try {
        loading.value = true
        await TipoSolicitacaoService.ativarOuInativarTipoSolicitacaoFormulario(
          tipoSolicitacaoId.value,
          formularioId.value,
          { ativar: !isAssociacaoAtiva.value },
        )
        emit('refetch-data')
      } finally {
        closeAssociarOuDesassociar()
        loading.value = false
      }
    }

    const ordensPermitidas = computed(() => Array.from({ length: props.items.filter(it => !!it.formularioId).length }, (_, index) => index + 1))

    const headers = [
      { text: 'NOME', value: 'nome' },
      { text: 'DESCRICAO', value: 'descricao' },
      { text: 'STATUS', value: 'ativo' },
      {
        text: 'OPÇÔES',
        value: 'actions',
        align: 'center',
      },
    ]

    return {
      isAtivarOuInativarAssociacaoTipoSolicitacaoFormularioDialogOpen,
      loading,
      tipoSolicitacaoId,
      formularioId,
      isAssociacaoAtiva,
      isAssociacaoAtivaMensagem,
      openEditFormulario,
      formularioAssociado,
      openEditFomulario,
      ativarOuInativarAssociacaoItem,
      openAssociarOuDesassociar,
      closeAssociarOuDesassociar,
      confirmarAtivacaoOuInativacaoDaAssociacao,
      ordensPermitidas,
      headers,
      icons: {
        mdiCheckBold,
        mdiCloseThick,
        mdiDotsVertical,
      },
      cursorPointer: item => (item.ativo || item.ativo === null ? 'cursor-pointer' : ''),
    }
  },
}
</script>
